import React from 'react'

import './index.scss'

export const Footer = () => (
  <footer className="footer">
    ©<a href="https://github.com/kostyrko">Kostyrko</a> [Built with{' '}
    <a href="https://github.com/JaeYeopHan/gatsby-starter-bee"></a>
      Gatsby-starter-bee (©<a href="https://github.com/JaeYeopHan">Jbee</a>)]
  </footer>
)
